module.exports = __webpack_public_path__ + "static/media/Group9336.3f5d0531.png";